import React from 'react';
import { Clock } from 'lucide-react';
interface RestaurantClosedBannerProps {
  /** Optional hint such as "Abrimos mañana a las 10:00 AM" */
  nextOpeningHint?: string | null;
  /** Optional dark theme (for NatuCafé / Cabaña) */
  variant?: 'light' | 'dark';
}
export function RestaurantClosedBanner({
  nextOpeningHint,
  variant = 'light'
}: RestaurantClosedBannerProps) {
  const isDark = variant === 'dark';
  return <div className={`border-b px-4 py-3 ${isDark ? 'bg-[#3A1F0F]/40 border-[#5C2F18]' : 'bg-red-50 border-red-100'}`} data-id="element-1890">
      <div className="max-w-5xl mx-auto flex items-start sm:items-center gap-3" data-id="element-1891">
        <Clock className={`w-5 h-5 shrink-0 mt-0.5 sm:mt-0 ${isDark ? 'text-[#FFB347]' : 'text-red-600'}`} data-id="element-1892" />
        <div className="flex-1 min-w-0" data-id="element-1893">
          <h3 className={`text-sm font-bold ${isDark ? 'text-[#FFB347]' : 'text-red-700'}`} data-id="element-1894">
            Restaurante cerrado
          </h3>
          <p className={`text-sm mt-0.5 ${isDark ? 'text-[#E8C9A0]/85' : 'text-red-700/80'}`} data-id="element-1895">
            {nextOpeningHint ? `${nextOpeningHint}. Mientras tanto, no podemos recibir pedidos.` : 'En este momento no podemos recibir pedidos. Vuelve durante nuestro horario de atención.'}
          </p>
        </div>
      </div>
    </div>;
}